app.controller("fileDetailController", [
	"$scope", "$filter", "newFileItem", "fileType", "fileOptions", "Session", "patientDocumentService", "countryConfig", "REFERRAL_PERIOD_TYPE",
	function ($scope, $filter, newFileItem, fileType, fileOptions, Session, patientDocumentService, countryConfig, REFERRAL_PERIOD_TYPE) {

		$scope.newFileItem = newFileItem;
		$scope.fileItem_fileType = fileType;

		// A referral is claimed against in AU only, and these are the two details ECLIPSE wants on
		// the claim, so they are only worth asking for there.
		$scope.referralProviderDetailsEnabled = countryConfig.countryCode === "AU";
		$scope.referralPeriods = REFERRAL_PERIOD_TYPE;

		// The analyser owns these two - they are what a file is while it is being identified, not
		// something a practice files a document as.
		const AI_FILE_TYPES = ['AI_ANALYSIS', 'AI_ANALYSIS_FAILED'];

		// Filter out AI types so they cannot be manually selected from the dropdown list. The type
		// the file already is stays in, though: the drop-down reads its selection off this list, so
		// dropping it would leave a file being analysed showing no type at all.
		$scope.fileOptions = fileOptions.filter(function (option) {
			return AI_FILE_TYPES.indexOf(option.id) === -1 || (fileType && option.id === fileType.id);
		});

		// Set while the file is one the analyser is still working on, so the form can say why it is
		// showing a type that cannot be picked rather than leaving it unexplained.
		$scope.aiAnalysisState = (fileType && AI_FILE_TYPES.indexOf(fileType.id) !== -1) ? fileType.id : null;

		$scope.securityOptions = patientDocumentService.getSecurityOptions();

		// Configures the multiselect directive to act as a single-select and read the 'name' property
		$scope.fileTypesSettings = {
			selectionLimit: 1,
			smartButtonMaxItems: 1,
			showCheckAll: false,
			showUncheckAll: false,
			closeOnSelect: true,
			displayProp: 'name',
			idProperty: 'id',
			externalIdProp: '',
			scrollable: true,
			scrollableHeight: '250px'
		};

		// Prevents console errors if the HTML is looking for the events object
		$scope.fileTypeEvents = {};

		const WITHIN_MY_PRACTICE = [
			"REFERRAL",
			"CLINIC_LETTER",
			"AGREEMENT_TO_TREATMENT",
			"CATQUEST",
			"SCANNED_HISTORIC_NOTES",
			"SCANNED_OPERATION_NOTE",
		];

		$scope.$watch(
			"fileItem_fileType",
			function (newValue, oldValue) {
				if (newValue) {
					// Ensure the underlying fileType ID updates so the save function sees the change
					$scope.newFileItem.fileType = newValue.id;

					if (WITHIN_MY_PRACTICE.includes(newValue.id)) {
						$scope.newFileItem.security_level = "PRACTICE";
					} else {
						$scope.newFileItem.security_level = "GLOBAL";
					}

					if (newValue.id === 'REFERRAL') {
						// No longer asked for on the form, so these stand as the values a referral
						// uploaded here is recorded with: issued today, to this practice, and the
						// reason and urgency a referral is usually uploaded under.
						$scope.newFileItem.dateOfReferral = $filter("date")(new Date(), "dd/MM/yyyy");
						$scope.newFileItem.referral_reason = 'SURGERY';
						$scope.newFileItem.referral_urgency = 'ROUTINE';
						$scope.newFileItem.referredToPracticeId = Session.practice.id;

						// Left blank rather than defaulted: the provider number has to be read off
						// the referral, and a period guessed here would be claimed against as if it
						// had been. Only initialised where nothing is set, so what an existing
						// referral already carries survives the form opening on it.
						if ($scope.referralProviderDetailsEnabled) {
							if ($scope.newFileItem.referral_provider_id === undefined) {
								$scope.newFileItem.referral_provider_id = '';
							}
							if ($scope.newFileItem.referral_period === undefined) {
								$scope.newFileItem.referral_period = '';
							}
							if ($scope.newFileItem.referral_period_months === undefined) {
								$scope.newFileItem.referral_period_months = '';
							}
						}
					} else {
						delete $scope.newFileItem.dateOfReferral;
						delete $scope.newFileItem.referral_reason;
						delete $scope.newFileItem.referral_urgency;
						delete $scope.newFileItem.referredToPracticeId;
						delete $scope.newFileItem.referredToUserId;
						delete $scope.newFileItem.referral_provider_id;
						delete $scope.newFileItem.referral_period;
						delete $scope.newFileItem.referral_period_months;
					}
				}
			},
			true
		);
	}
]);